// The app version is injected at build time from the repo VERSION file
// (REACT_APP_VERSION build arg). Falls back to 'dev' for local runs without it.
export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
